export default class GTagHelper {
    public static setConfig(targetId: string, configInfo: any = null) {
        if ((<any>window).gtag) {
            (<any>window).gtag("config", targetId, configInfo);
        }
    }

    // Get values from gtag (including values set with the set command)
    public static getValue(target: string, fieldName: string) {
        if ((<any>window).gtag) {
            (<any>window).gtag("get", target, fieldName, (field: any) => { return field });
        }
    }

    // Set values that persist across all the subsequent gtag() calls on the page
    public static setValue(valuePair: any) {
        if ((<any>window).gtag) {
            (<any>window).gtag("set", valuePair);
        }
    }

    public static sendEvent(name: string, category: string, label?: string, value?: number) {
        let parameters: any = { category: category };

        if (label) {
            parameters.label = label;
        }

        if (value) {
            parameters.value = value;
        }

        if ((<any>window).gtag) {
            (<any>window).gtag("event", name, parameters);
        }
    }

    public static sendCustomEvent(name: string, parameters: any = null) {
        if ((<any>window).gtag) {
            (<any>window).gtag("event", name, parameters);
        }
    }

    public static sendPageView(parameters: any = null) {
        if ((<any>window).gtag) {
            (<any>window).gtag("event", "page_view", parameters);
        }
    }
}